import { INE_CONTACT_SALES } from 'constants/settings';

interface ContactSalesAccount {
  sales_contact?: {
    email?: string;
  };
}

interface ContactSalesOptions {
  /** URL-encoded value for the mailto subject query parameter. */
  subject?: string;
  /** URL-encoded value for the mailto body query parameter. */
  body?: string;
}

export const buildContactSalesMailto = (
  account: ContactSalesAccount | null | undefined,
  { subject, body }: ContactSalesOptions = {}
): string => {
  const salesEmail = account?.sales_contact?.email;
  const recipients = salesEmail ? `${INE_CONTACT_SALES},${salesEmail}` : INE_CONTACT_SALES;
  const params = [subject && 'subject=' + subject, body && 'body=' + body]
    .filter((param): param is string => typeof param === 'string')
    .join('&');
  return params ? `mailto:${recipients}?${params}` : `mailto:${recipients}`;
};
